
export const viewMoreBtnStyle = {
    ...(
      process.env.REACT_APP__UI_CUSTOMIZATION__USE_REWARD_PAGE__USE_LATER_BUTTON_BACKGROUND_COLOR
        ? { backgroundColor: process.env.REACT_APP__UI_CUSTOMIZATION__USE_REWARD_PAGE__USE_LATER_BUTTON_BACKGROUND_COLOR }
        : {}
    ),
    ...(
      process.env.REACT_APP__UI_CUSTOMIZATION__USE_REWARD_PAGE__USE_LATER_BUTTON_TEXT_COLOR
        ? { color: process.env.REACT_APP__UI_CUSTOMIZATION__USE_REWARD_PAGE__USE_LATER_BUTTON_TEXT_COLOR }
        : {}
    )
  };

  export const scanToRedeemButtonStyle = {
    ...(
      process.env.REACT_APP__UI_CUSTOMIZATION__USE_REWARD_PAGE__SCAN_QR_TO_REDEEM_BUTTON_BACKGROUND_COLOR
        ? { backgroundColor: process.env.REACT_APP__UI_CUSTOMIZATION__USE_REWARD_PAGE__SCAN_QR_TO_REDEEM_BUTTON_BACKGROUND_COLOR }
        : {}
    ),
    ...(
      process.env.REACT_APP__UI_CUSTOMIZATION__USE_REWARD_PAGE__SCAN_QR_TO_REDEEM_BUTTON_TEXT_COLOR
        ? { color: process.env.REACT_APP__UI_CUSTOMIZATION__USE_REWARD_PAGE__SCAN_QR_TO_REDEEM_BUTTON_TEXT_COLOR }
        : {}
    )
  };
